import { render, staticRenderFns } from "./FilesNc.vue?vue&type=template&id=ea3dd89e"
import script from "./FilesNc.vue?vue&type=script&lang=js"
export * from "./FilesNc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports